import { useEffect, useRef } from 'react';
import { matchPath, matchRoutes, Outlet, useLocation } from 'react-router-dom';
import cn from 'classnames';

import AlertPopup from '@/components/AlertPopup';
import BuildVersion from '@/components/BuildVersion';
import Footer from '@/components/common/Footer';
import Toast from '@/components/Toast';
import { EXCEPT_LNB_ROUTES, PARTNER_ROUTES, ROUTES } from '@/constants/routes';
import GNBLayout from '@/outlets/ContainerOutlet/GNBLayout';
import LNBLayout from '@/outlets/ContainerOutlet/LNBLayout';
import { useAuthStore } from '@/store/auth';
import { usePartnerStore } from '@/store/partner';
import { isDev } from '@/utils/phase';

const ContainerOutlet = () => {
  const { bizTargetType } = useAuthStore();
  const { resetSearchedPartner } = usePartnerStore();

  const outerRef = useRef<HTMLDivElement>(null);

  const location = useLocation();
  const { pathname } = location;
  const isLnbOpen = bizTargetType && !matchRoutes(EXCEPT_LNB_ROUTES, location);

  // "이용기관 관리"를 벗어나는 경우 조회 정보 제거
  useEffect(() => {
    const isPartnerPage = matchRoutes(PARTNER_ROUTES, location);
    !isPartnerPage && resetSearchedPartner();
  }, [pathname]);

  const isDashboardPage = matchPath(ROUTES.DASHBOARD, pathname);

  return (
    <div ref={outerRef} className={cn('container-doc', { type_full_w: !isLnbOpen })}>
      <GNBLayout />
      <main className="doc-main">
        <div className="main-content">
          {isDev && <BuildVersion />}
          {isLnbOpen && <LNBLayout outerRef={outerRef} />}
          <article id="mainContent" className={cn('content-article', { 'content-dashboard': isDashboardPage })}>
            <Outlet context={{ outerRef }} />
            <div id="layer" />
            <Toast />
            <AlertPopup />
          </article>
        </div>
      </main>
      <Footer>
        <Footer.Item linkUrl="https://kakaobusiness-policy.kakao.com/SERVICE/?redirect=false">
          카카오비즈니스 이용약관
        </Footer.Item>
        <Footer.Item linkUrl={`${window.location.origin}${ROUTES.TERMS}`}>카카오톡 지갑파트너센터 이용약관</Footer.Item>
        <Footer.Item linkUrl="https://business.kakao.com/policy/privacy">비즈니스파트너 개인정보처리방침</Footer.Item>
        <Footer.Item linkUrl="https://www.kakao.com/policy/oppolicy?lang=ko">운영정책</Footer.Item>
        <Footer.Item linkUrl="https://cs.kakao.com/helps?service=233">고객센터</Footer.Item>
      </Footer>
    </div>
  );
};

export default ContainerOutlet;
